export const APP_NAME = "parcelizer";
export const TOKEN_NAME = "_parcelizer_session";

export const REACT_APP_GOOGLE_API = process.env.REACT_APP_GOOGLE_API;
export const REACT_APP_MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

export const PAGE_SIZE = 10;

export const REGEX_PHONE = /^[+]{1}(?:[0-9\-\(\)\/\.]\s?){6, 15}[0-9]{1}$/;

export const TIME_FORMAT_FRONTEND = "HH:mm";
export const DATE_FORMAT_FRONTEND = "ddd, DD MMM, YYYY";
export const DATETIME_FORMAT_FRONTEND = "ddd, DD MMM, YYYY hh:mm A";
export const DATETIME_FORMAT_FRONTEND_PDF = "HH:mm, DD MMM, YYYY";
export const DATETIME_SIMPLY_FORMAT_FRONTEND = "DD/MM/YYYY hh:mm";
export const DATE_FORMAT_BACKEND = "YYYY/MM/DD";
export const DATE_FORMAT_QUERY = "YYYY-MM-DD";

export const ONE_HOUR_PX = 300; //px
export const LEFT_DEFAULT = 21; //px

export const UPLOADED_TIME_ORDER = "uploadedTime";

export const ENGINE_TYPE = {
  OSRM: "OSRM",
  GMPRO: "GMPRO",
  GOOGLE_D_API: "Google Direction API",
};

export const ENGINE_TYPE_TRANSLATION = {
  OSRM: "Open Street Maps",
  GMPRO: "GMPRO",
  GOOGLE_D_API: "Routes API",
};

export const INDUSTRIES = [
  "We deliver meal prep or prepared food items",
  "We deliver groceries",
  "We deliver hot food",
  "We are consultants / system integrators",
  "We are a field services company",
  "We run a ride sharing fleet",
  "We are a third party logistics / courier company",
  "We manage sales representatives in the field",
  "We provide software as a service",
  "We provide waste management or recycling services",
  "We deliver products that we sell online",
  "We deliver marijuana or alcohol",
  "We run a passenger bus service",
  "We pickup and deliver laundry",
  "We are a non profit",
  "Other",
];

export const EVENTS = [
  "routeplan.dispatch",
  "routeplan.dispatch.update",
  "order.pickup.arrived",
  "order.pickup.completed",
  "order.pickup.failed",
  "order.delivery.arrived",
  "order.delivery.completed",
  "order.delivery.failed",
];

export const NUM_OF_DRIVERS = ["1 - 4", "5 - 10", "11+"];

export const COLOR_DEFAULT = "7732EF";
export const OLD_COLORS = [
  "00C8B4",
  "00E509",
  "9E69E0",
  "9FDC70",
  "23A9F6",
  "83C3FF",
  "641EFD",
  "669A3D",
  "748BFF",
  "C64EFF",
  "DC70C4",
  "F58585",
  "FF3535",
  "FF9365",
  "FFAB00",
  "606060",
  "7732EF",
];
export const COLORS = [
  "ed8f8f",
  "f284a8",
  "c788d2",
  "aa92d6",
  "959ed5",
  "85c3f8",
  "76cef9",
  "75c4bc",

  "cd2929",
  "d21a55",
  "8321a0",
  "532fa8",
  "1c7de1",
  "0790e1",
  "00a2b9",
  "007e70",

  "ae1a1a",
  "7d1046",
  "411481",
  "2b1a87",
  "0f3e97",
  "044d90",
  "005559",
  "004438",

  "9bd09d",
  "bddd9b",
  "e2eb91",
  "fff392",
  "ffc575",
  "ffa186",
  "d1c5c1",
  "c8d2d7",

  "3b963e",
  "71aa3a",
  "b8c32d",
  "fdd22f",
  "fa8100",
  "f2471c",
  "826358",
  "859aa4",

  "1a531d",
  "2d5e1c",
  "776c17",
  "f37417",
  "e24700",
  "b72f0f",
  "533830",
  "3c5059",
];

export const STATUS = [
  {
    code: "DRAFT",
    name: "Draft",
  },
  {
    code: "ERROR",
    name: "Error",
  },
  {
    code: "GEOCODING",
    name: "Geocoding",
  },
  {
    code: "UNASSIGNED",
    name: "Unassigned",
  },
  {
    code: "ASSIGNED",
    name: "Assigned",
  },
  {
    code: "UNSCHEDULED",
    name: "Unscheduled",
  },
  {
    code: "GOING_NEXT",
    name: "Going Next",
  },
  {
    code: "SKIPPED",
    name: "Skipped",
  },
  {
    code: "PICKUP_ARRIVED",
    name: "Pickup Arrived",
  },
  {
    code: "PICKUP_FAILED",
    name: "Pickup Failed",
  },
  {
    code: "COLLECTED",
    name: "Collected",
  },
  {
    code: "IN_TRANSIT",
    name: "In Transit",
  },
  {
    code: "DELIVERY_ARRIVED",
    name: "Delivery Arrived",
  },
  {
    code: "DELIVERY_FAILED",
    name: "Delivery Failed",
  },
  {
    code: "COMPLETED",
    name: "Completed",
  },
  {
    code: "FAILED",
    name: "Failed",
  },
];

export const PARTNER_STATUSES = [
  { name: "Active", value: true },
  { name: "Inactive", value: false },
];

export const COMPANY_ACCOUNT_TYPIES = [
  { name: "Parcelizer", value: "DEFAULT" },
  { name: "Partner", value: "PARTNER" },
  { name: "White Label", value: "WHITE_LABEL" },
];

export const OPTIMIZATION_PREFERENCE = [
  {
    name: "Straight Line",
    value: "straight_line",
    desc: "Fast but less accurate",
  },
  {
    name: "Driving Distance",
    value: "distance_travelled",
    desc: "More accurate and practical, but slow",
  },
];

export const ROUTE_PLAN_TYPIES = [
  { name: "Single Stop", value: "VRP" },
  { name: "Pickup and Delivery", value: "PDP" },
];

export const OPTIMIZED_TYPES = [
  { name: "Time", value: "time" },
  { name: "Distance", value: "distance" },
];

export const LANGUAGES = {
  auto: "Automatic",
  af: "Afrikaans",
  sq: "Albanian",
  ar: "Arabic",
  hy: "Armenian",
  az: "Azerbaijani",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali",
  bs: "Bosnian",
  bg: "Bulgarian",
  ca: "Catalan",
  ceb: "Cebuano",
  ny: "Chichewa",
  "zh-cn": "Chinese Simplified",
  "zh-tw": "Chinese Traditional",
  co: "Corsican",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  nl: "Dutch",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  tl: "Filipino",
  fi: "Finnish",
  fr: "French",
  fy: "Frisian",
  gl: "Galician",
  ka: "Georgian",
  de: "German",
  el: "Greek",
  gu: "Gujarati",
  ht: "Haitian Creole",
  ha: "Hausa",
  haw: "Hawaiian",
  iw: "Hebrew",
  hi: "Hindi",
  hmn: "Hmong",
  hu: "Hungarian",
  is: "Icelandic",
  ig: "Igbo",
  id: "Indonesian",
  ga: "Irish",
  it: "Italian",
  ja: "Japanese",
  jw: "Javanese",
  kn: "Kannada",
  kk: "Kazakh",
  km: "Khmer",
  ko: "Korean",
  ku: "Kurdish (Kurmanji)",
  ky: "Kyrgyz",
  lo: "Lao",
  la: "Latin",
  lv: "Latvian",
  lt: "Lithuanian",
  lb: "Luxembourgish",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay",
  ml: "Malayalam",
  mt: "Maltese",
  mi: "Maori",
  mr: "Marathi",
  mn: "Mongolian",
  my: "Myanmar (Burmese)",
  ne: "Nepali",
  no: "Norwegian",
  ps: "Pashto",
  fa: "Persian",
  pl: "Polish",
  pt: "Portuguese",
  ma: "Punjabi",
  ro: "Romanian",
  ru: "Russian",
  sm: "Samoan",
  gd: "Scots Gaelic",
  sr: "Serbian",
  st: "Sesotho",
  sn: "Shona",
  sd: "Sindhi",
  si: "Sinhala",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali",
  es: "Spanish",
  su: "Sudanese",
  sw: "Swahili",
  sv: "Swedish",
  tg: "Tajik",
  ta: "Tamil",
  te: "Telugu",
  th: "Thai",
  tr: "Turkish",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  vi: "Vietnamese",
  cy: "Welsh",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  zu: "Zulu",
};

export const DEFAULT_TRANSLATION = {
  Menu: {
    "Route Plans": "Route Plans",
    Orders: "Orders",
    Drivers: "Drivers",
    "User Groups": "User Groups",
    Users: "Users",
    "Message Logs": "Message Logs",
    Companies: "Companies",
    "Sub Account": "Sub Account",
    "Comp Admins": "Comp Admins",
    Partners: "Partners",
    Pricing: "Pricing",
    Docs: "Docs",
    Settings: "Settings",
    Reports: "Reports",
    "Log Out": "Log Out",
  },
  Settings: {
    "General Settings": "General Settings",
    "Go to Stop": "Go to Stop",
    "Buffer Percentage": "Buffer Percentage",
    "Default Route Plan Type": "Default Route Plan Type",
    "Optimization Mode": "Optimization Mode",
    "Optimization Preference": "Optimization Preference",
    "Straight Line": "Straight Line",
    "Fast but less accurate": "Fast but less accurate",
    "Driving Distance": "Driving Distance",
    "More accurate and practical, but slow": "More accurate and practical, but slow",
    "Allow Late Stops": "Allow Late Stops",
    "Customer Call Direction": "Customer Call Direction",
    "Customer Service Hotline": "Customer Service Hotline",
    "Driver Phone": "Driver Phone",
    "Service Time": "Service Time",
    "Data Source": "Data Source",
    "Google Directions Key": "Google Directions Key",
    "Geocode Google Key": "Geocode Google Key",
    Minutes: "Minutes",
    Reassign: "Reassign",
    "Force Reassign": "Force Reassign",
    Token: "Token",
    "Default Location": "Default Location",
    Name: "Name",
    "Phone Number": "Phone Number",
    Address: "Address",
    "Notification Settings": "Notification Settings",
    "How will your customers receive notifications?": "How will your customers receive notifications?",
    "Text Message": "Text Message",
    Email: "Email",
    "Text Message & Email": "Text Message & Email",
    "What does the notification message say?": "What does the notification message say?",
    "These notification fields are available": "These notification fields are available",
    "Click to copy": "Click to copy",
    Copied: "Copied",
    "Dispatch Notification": "Dispatch Notification",
    "Dispatch Notification Desc":
      "Sends a notification to the dropoff customer letting him know the date and time his delivery is scheduled to arrive.",
    "Going Next": "Going Next",
    "Going Next Desc":
      "Sends a notification to the pickup or dropoff customer when the driver hits 'going next' on the app. The notification includes a real time ETA (estimated arrival time) and a link to a real time map showing where the driver is right now.",
    "Order Completion": "Order Completion",
    "Order Completion Desc":
      "Sends a notification to the dropoff customer when the driver clicks 'complete' on the app.",
    "Preview on mobile": "Preview on mobile",
    Integration: "Integration",
    "Brand Settings": "Brand Settings",
    "Company Logo": "Company Logo",
    "Primary Color": "Primary Color",
    Language: "Language",
    "System Language": "System Language",
    Position: "Position",
    Translation: "Translation",
    "Reset Default Translation": "Reset Default Translation",
    "Webhook Configuration": "Webhook Configuration",
    "End Point URL": "End Point URL",
    Description: "Description",
    "List of Events": "List of Events",
    "Routing Engine": "Routing Engine",
    "Google Maps API Key": "Google Maps API Key",
  },
  "Route Plans": {
    "Download Labels": "Download Labels",
    "Route Plans": "Route Plans",
    "Create New Route Plan with Selected Orders": "Create New Route Plan with Selected Orders",
    "Create New Route Plan with Selected Contacts": "Create New Route Plan with Selected Contacts",
    "Edit Route Plan": "Edit Route Plan",
    "New Route Plan": "New Route Plan",
    "Route Plan Name": "Route Plan Name",
    Type: "Type",
    "Single Stop": "Single Stop",
    "Pickup and Delivery": "Pickup and Delivery",
    Date: "Date",
    "# of Orders": "# of Orders",
    "# of Drivers": "# of Drivers",
    "Updated At": "Updated At",
    Distance: "Distance",
    "Travel Time": "Travel Time",
    "Service Time": "Service Time",
    "Working Time": "Working Time",
    "Waiting Time": "Waiting Time",
    Travel: "Travel",
    Service: "Service",
    Working: "Working",
    Waiting: "Waiting",
    "Working %": "Working %",
    Status: "Status",
    mins: "mins",
    "Add Drivers": "Add Drivers",
    "Add Orders": "Add Orders",
    "Continue to Route": "Continue to Route",
    "drivers selected": "drivers selected",
    "orders selected": "orders selected",
    "contacts selected": "contacts selected",
    "Add to Route": "Add to Route",
    "Add to Route and Optimize": "Add to Route and Optimize",
    "Search Anything": "Search Anything",
    Timeline: "Timeline",
    Dispatch: "Dispatch",
    "Create New Driver": "Create New Driver",
    "Waiting to dispatch": "Waiting to dispatch",
    "Missing phone number": "Missing phone number",
    Drivers: "Drivers",
    "# of Stops": "# of Stops",
    "Phone Number": "Phone Number",
    "Route URL": "Route URL",
    "Last Update": "Last Update",
    Unscheduled: "Unscheduled",
    "Force Schedule All": "Force Schedule All",
    Completed: "Completed",
    Missed: "Missed",
    Scheduled: "Scheduled",
    "Download Solution": "Download Solution",
    "Download Summary": "Download Summary",
    Summary: "Summary",
    Undo: "Undo",
    Redo: "Redo",
    Revert: "Revert",
    Apply: "Apply",
    "Optimize Route": "Optimize Route",
    "Dispatch to Drivers": "Dispatch to Drivers",
    "Dispatch Update": "Dispatch Update",
    "Order Status Update": "Order Status Update",
    "Do not refresh": "Do not refresh",
    Refresh: "Refresh",
    "Would you like to refresh? (You will lose any changes since the last optimization.)":
      "Would you like to refresh? (You will lose any changes since the last optimization.)",
    DRAFT: "Draft",
    OPTIMIZED: "Optimized",
    DISPATCHED: "Dispatched",
    "Seen by Driver at": "Seen by Driver at",
    "Reassign to another driver": "Reassign to another driver",
  },
  Orders: {
    "Current location": "Current location",
    "Please unlock the selected driver first": "Please unlock the selected driver first",
    "Search Header": "Search Header",
    Labels: "Labels",
    "Select Order Type": "Select Order Type",
    Add: "Add",
    Added: "Added",
    Orders: "Orders",
    "Order ID": "Order ID",
    "Order Ref": "Order Ref",
    Type: "Type",
    Date: "Date",
    "Delivery Date": "Delivery Date",
    "Pickup Name": "Pickup Name",
    "Pickup Address": "Pickup Address",
    "Pickup Phone": "Pickup Phone",
    "Pickup Phone Number": "Pickup Phone Number",
    "Pickup Email": "Pickup Email",
    "Pickup Time Window": "Pickup Time Window",
    "Pickup From": "Pickup From",
    "Pickup To": "Pickup To",
    "Pickup Duration": "Pickup Duration",
    "Pickup Duration (minutes)": "Pickup Duration (minutes)",
    "Delivery Name": "Delivery Name",
    "Delivery Address": "Delivery Address",
    "Delivery Phone": "Delivery Phone",
    "Delivery Phone Number": "Delivery Phone Number",
    "Delivery Email": "Delivery Email",
    "Delivery Time Window": "Delivery Time Window",
    "Delivery From": "Delivery From",
    "Delivery To": "Delivery To",
    "Delivery Duration": "Delivery Duration",
    "Delivery Duration (minutes)": "Delivery Duration (minutes)",
    "User Group": "User Group",
    "Date Added": "Date Added",
    "Updated At": "Updated At",
    Status: "Status",
    "orders selected": "orders selected",
    Upload: "Upload",
    "Single Order": "Single Order",
    "New Order": "New Order",
    "New Single Order": "New Single Order",
    "OK I got this": "OK I got this",
    "Error details": "Error details",
    Delete: "Delete",
    "Bulk Update": "Bulk Update",
    "Create New Route Plan with Selected Orders": "Create New Route Plan with Selected Orders",
    "Failed to Create New Route Plan": "Failed to Create New Route Plan",
    "You cannot create new route plan with orders on different dates. Please select orders on the same date and try again.":
      "You cannot create new route plan with orders on different dates. Please select orders on the same date and try again.",
    "Failed to Add to Existing Route Plan": "Failed to Add to Existing Route Plan",
    "You cannot add orders on different dates to an existing route plan. Please select orders on the same date and try again.":
      "You cannot add orders on different dates to an existing route plan. Please select orders on the same date and try again.",
    "Add to Existing Route Plan": "Add to Existing Route Plan",
    "Only orders in draft status can be added to a new or existing route plan":
      "Only orders in draft status can be added to a new or existing route plan",
    "Select Route Plan": "Select Route Plan",
    "Bulk Delete": "Bulk Delete",
    "Are you sure you want to delete the orders below?": "Are you sure you want to delete the orders below?",
    "Add Attribute": "Add Attribute",
    "Add from Contact List": "Add from Contact List",
    Matched: "Matched",
    "Bulk Update Pickup": "Bulk Update Pickup",
    "Bulk Update Delivery": "Bulk Update Delivery",
    "Edit Order Info": "Edit Order Info",
    "Edit Pickup": "Edit Pickup",
    "Edit Delivery": "Edit Delivery",
    Pickup: "Pickup",
    pickup: "pickup",
    Delivery: "Delivery",
    delivery: "delivery",
    "Order Info": "Order Info",
    Types: "Types",
    "Pickup Notes": "Pickup Notes",
    "Delivery Notes": "Delivery Notes",
    "Custom Fields": "Custom Fields",
    "Add Custom Field": "Add Custom Field",
    "Field Input": "Field Input",
    "Field Title": "Field Title",
    "Add Single Order": "Add Single Order",
    "Upload New Orders": "Upload New Orders",
    "Match Header Data": "Match Header Data",
    "View on Route Plan": "View on Route Plan",
    Address: "Address",
    Email: "Email",
    "Phone Number": "Phone Number",
    "Time Window": "Time Window",
    Duration: "Duration",
    POD: "POD",
    Signature: "Signature",
    "Driver notes": "Driver notes",
    "Package was": "Package was",
    "Add Header": "Add Header",
    ERROR: "Error",
    DRAFT: "Draft",
    GEOCODING: "Geocoding",
    UNASSIGNED: "Unassigned",
    ASSIGNED: "Assigned",
    UNSCHEDULED: "Unscheduled",
    GOING_NEXT: "Going next",
    SKIPPED: "Skipped",
    PICKUP_ARRIVED: "Pickup arrived",
    PICKUP_FAILED: "Pickup failed",
    COLLECTED: "Collected",
    IN_TRANSIT: "In transit",
    DELIVERY_ARRIVED: "Delivery arrived",
    DELIVERY_FAILED: "Delivery failed",
    COMPLETED: "Completed",
    "Customer Name": "Customer Name",
    "Job Type": "Job Type",
    "Arv. Time": "Arv. Time",
    "Fin. Time": "Fin. Time",
    "Arrival Time": "Arrival Time",
    "Finish Time": "Finish Time",
    Distance: "Distance",
    "Travel Time": "Travel Time",
    "Service Time": "Service Time",
    "Working Time": "Working Time",
    "Waiting Time": "Waiting Time",
    "TRACKING ORDER": "TRACKING ORDER",
    "Pickup Location": "Pickup Location",
    "Delivery Location": "Delivery Location",
    "PROOF OF DELIVERY": "PROOF OF DELIVERY",
    Photos: "Photos",
    Load: "Load",
    Driver: "Driver",
    Draft: "Draft",
    Assigned: "Assigned",
    Skipped: "Skipped",
    "Pickup Arrived": "Pickup Arrived",
    "Pickup Failed": "Pickup Failed",
    Collected: "Collected",
    "In Transit": "In Transit",
    "Delivery Arrived": "Delivery Arrived",
    "Delivery Failed": "Delivery Failed",
    Completed: "Completed",
    "Start Date": "Start Date",
    "End Date": "End Date",
    "Route Plan Name": "Route Plan Name",
  },
  Drivers: {
    Drivers: "Drivers",
    "New Driver": "New Driver",
    "Edit Driver": "Edit Driver",
    "Driver Name": "Driver Name",
    "Date Added": "Date Added",
    Name: "Name",
    Email: "Email",
    Phone: "Phone",
    "Phone Number": "Phone Number",
    "Shift Time": "Shift Time",
    Capacity: "Capacity",
    "Shift Start": "Shift Start",
    "Shift End": "Shift End",
    "Break Start": "Break Start",
    "Break End": "Break End",
    "Break Start": "Break Start",
    "Break End": "Break End",
    "Start Location": "Start Location",
    "End Location": "End Location",
    "Driver Skills": "Driver Skills",
    "Updated At": "Updated At",
    "Time Started First Job": "Time Started First Job",
    "Time Ended Last Job": "Time Ended Last Job",
    Speed: "Speed",
    "X2 Slower": "X2 Slower",
    Slower: "Slower",
    Slow: "Slow",
    Normal: "Normal",
    Fast: "Fast",
    Faster: "Faster",
    "X2 Faster": "X2 Faster",
    "Time Shift": "Time Shift",
  },
  "User Groups": {
    "User Groups": "User Groups",
    "New Group": "New Group",
    "Edit Group": "Edit Group",
    Invite: "Invite",
    "Invite user to": "Invite user to",
    "Invite User": "Invite User",
    Group: "Group",
    "Invite Users to Group": "Invite Users to Group",
    "User Email Address": "User Email Address",
    Add: "Add",
    "Invite Via Link": "Invite Via Link",
    "Anyone with the link can join as user": "Anyone with the link can join as user",
    "Turn Off Link": "Turn Off Link",
    "Turn On Link": "Turn On Link",
    "Manage Users": "Manage Users",
    "Invite Pending": "Invite Pending",
    Accepted: "Accepted",
    "Group Name": "Group Name",
    Users: "Users",
    "# of Users": "# of Users",
    "Date Added": "Date Added",
  },
  Users: {
    Users: "Users",
    "Edit User": "Edit User",
    "New User": "New User",
    "Invite User": "Invite User",
    "User Name": "User Name",
    "Email Address": "Email Address",
    Groups: "Groups",
    Name: "Name",
    Password: "Password",
    "Use default password": "Use default password",
    "User Groups": "User Groups",
    "Created Date": "Created Date",
    Email: "Email",
  },
  "Message Logs": {
    Date: "Date",
    Time: "Time",
    "Route Plan": "Route Plan",
    From: "From",
    To: "To",
    Message: "Message",
    Status: "Status",
    "You have a new route plan": "You have a new route plan",
    SENT: "SENT",
    DELIVERED: "DELIVERED",
    UNDELIVERED: "UNDELIVERED",
    FAILED: "FAILED",
  },
  Contacts: {
    Contacts: "Contacts",
    "Contact List": "Contact List",
    "New Contact": "New Contact",
    "Edit Contact": "Edit Contact",
    Name: "Name",
    Phone: "Phone",
    "Phone Number": "Phone Number",
    Address: "Address",
    "Time Window": "Time Window",
    "Start Time": "Start Time",
    "End Time": "End Time",
    Notes: "Notes",
    Types: "Types",
    Load: "Load",
    Delete: "Delete",
    "Create New Route Plan with Selected Contacts": "Create New Route Plan with Selected Contacts",
    "Add to Existing Route Plan": "Add to Existing Route Plan",
    selected: "selected",
    "Bulk Delete": "Bulk Delete",
    "Are you sure you want to delete the contacts below?": "Are you sure you want to delete the contacts below?",
    Duration: "Duration",
    "Updated At": "Updated At",
    "Select a contact": "Select a contact",
    "Single Contact": "Single Contact",
    Upload: "Upload",
    "Upload New Contacts": "Upload New Contacts",
    "Match Header Data": "Match Header Data",
  },
  Companies: {
    "Company Name": "Company Name",
    "Company Partner Name": "Company Partner Name",
    "Company Admin Email": "Company Admin Email",
    Email: "Email",
    "Created Date": "Created Date",
    Branding: "Branding",
    "# of Drivers": "# of Drivers",
    "New Sub Account": "New Sub Account",
    "Edit Sub Account": "Edit Sub Account",
    "Create Sub Account": "Create Sub Account",
  },
  Common: {
    "Current Route Plan": "Current Route Plan",
    Date: "Date",
    Stops: "Stops",
    Drivers: "Drivers",
    Filter: "Filter",
    View: "View",
    Reset: "Reset",
    Apply: "Apply",
    Confirm: "Confirm",
    Cancel: "Cancel",
    Create: "Create",
    Update: "Update",
    Duplicate: "Duplicate",
    Remove: "Remove",
    Done: "Done",
    page: "page",
    "Select all": "Select all",
    "Are you sure to delete this item?": "Are you sure to delete this item?",
    "Are you sure to duplicate this item?": "Are you sure to duplicate this item?",
    "Show more": "Show more",
    "View Order Details": "View Order Details",
    "Go to Delivery": "Go to Delivery",
    "Go to Pickup": "Go to Pickup",
    "Go to": "Go to",
    "Move to Unscheduled": "Move to Unscheduled",
    Yes: "Yes",
    No: "No",
    Continue: "Continue",
    "Download Sample File": "Download Sample File",
    "Need help": "Need help",
    "View Demo Video": "View Demo Video",
  },
};
